export default __webpack_public_path__ + "static/Image050-Player_small-46b383c2be1ab9aa3e0300093daac479.png";